import { useState } from 'react';
import styles from '../css/CopyrightHolders.module.css';

const CopyrightHolders = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    recipient: 'Admin (Администраторы)',
    subject: '',
    message: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Form submitted:', formData);
    alert('Сообщение отправлено! Мы свяжемся с вами в ближайшее время.');
    setFormData({
      name: '',
      email: '',
      recipient: 'Admin (Администраторы)',
      subject: '',
      message: ''
    });
  };

  return (
    <div className={styles.copyrightPage}>
      <div className={styles.container}>
        <h1 className={styles.title}>Правообладателям</h1>

        <div className={styles.content}>
          <p className={styles.paragraph}>
            Руководство портала DoramaHype действует в соответствии с законодательством Республики Казахстан,
            включая нормы Закона РК «Об авторском праве и смежных правах», а также Закона «Об информации и коммуникациях».
            Мы соблюдаем процедуры добровольного урегулирования споров, связанных с интеллектуальной собственностью,
            и оперативно реагируем на обращения правообладателей.
          </p>

          <p className={styles.paragraph}>
            Вся информация, размещенная на сайте, предназначена исключительно для ознакомительных целей и является общедоступной.
            Публикация материалов на интернет-портале осуществляется пользователями. После заполнения формы добавления,
            контент может быть автоматически отредактирован или дополнен сведениями из открытых источников сети Интернет.
          </p>

          <p className={styles.paragraph}>
            Видео- и медиафайлы также добавляются пользователями путем указания прямых ссылок на файлы или другие источники.
            Данный вид материалов может автоматически обрабатываться средствами технической конвертации. Исходя из этого,
            администрация портала не несет ответственности за соблюдение авторских прав на материалы, добавленные пользователями.
          </p>

          <p className={styles.paragraph}>
            Если вы являетесь правообладателем определённого контента и считаете, что сайт DoramaHype нарушает ваши права,
            просим как можно быстрее связаться с нами по адресу:
          </p>

          <p className={styles.email}>
            📧 doramahype@gmail.com
          </p>

          <div className={styles.requirements}>
            <h2 className={styles.subtitle}>Для обработки обращения необходимо:</h2>

            <p className={styles.paragraph}>
              Предоставить документальное подтверждение ваших прав на материал, защищённый авторским правом.
              Подойдут любые из следующих документов:
            </p>

            <ul className={styles.list}>
              <li>Отсканированная копия или качественная фотография официального документа с печатью.</li>
              <li>Электронное письмо, отправленное с официального домена компании-правообладателя.</li>
              <li>Любой иной документ или информация, однозначно подтверждающие правообладание.</li>
            </ul>

            <p className={styles.paragraph}>
              Указать прямые ссылки на страницы нашего сайта, где размещён материал, который, по вашему мнению, нарушает ваши права.
            </p>

            <p className={styles.paragraph}>
              После получения корректно оформленного обращения, сопровождаемого подтверждающими документами,
              администрация портала обязательно свяжется с вами для мирного и оперативного урегулирования вопроса.
            </p>
          </div>

          <div className={styles.formSection}>
            <h2 className={styles.subtitle}>Форма обращения</h2>

            <form className={styles.form} onSubmit={handleSubmit}>
              <div className={styles.formGroup}>
                <label htmlFor="name" className={styles.label}>Ваше имя:</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  placeholder="Ваше имя"
                  className={styles.input}
                  required
                />
              </div>

              <div className={styles.formGroup}>
                <label htmlFor="email" className={styles.label}>Ваш E-Mail:</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="Ваш E-Mail"
                  className={styles.input}
                  required
                />
              </div>

              <div className={styles.formGroup}>
                <label htmlFor="recipient" className={styles.label}>Выберите кому:</label>
                <select
                  id="recipient"
                  name="recipient"
                  value={formData.recipient}
                  onChange={handleChange}
                  className={styles.select}
                  required
                >
                  <option value="Admin (Администраторы)">Admin (Администраторы)</option>
                </select>
              </div>

              <div className={styles.formGroup}>
                <label htmlFor="subject" className={styles.label}>Тема сообщения:</label>
                <input
                  type="text"
                  id="subject"
                  name="subject"
                  value={formData.subject}
                  onChange={handleChange}
                  placeholder="Тема сообщения"
                  className={styles.input}
                  required
                />
              </div>

              <div className={styles.formGroup}>
                <label htmlFor="message" className={styles.label}>Ваше письмо:</label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  placeholder="Ваше письмо"
                  className={styles.textarea}
                  rows="8"
                  required
                ></textarea>
              </div>

              <button type="submit" className={styles.submitButton}>
                Отправить сообщение
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CopyrightHolders;
